import {Component, OnInit} from '@angular/core';
import {AdminService} from '../admin.service';
import _ from 'lodash';
import {ApiService} from '../../services/api.service';
import {NotificationsService} from 'angular2-notifications';
import {TranslateService} from '@ngx-translate/core';
import {GenericModalComponent} from '../../generic-modal/generic-modal.component';
import {ModalService} from '../../services/modalService/modal.service';

@Component({
  selector: 'app-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.css']
})
export class ManageUsersComponent implements OnInit {

  public usersList: Array<any> = [];
  currentUser: any = {};
  ruid: string = undefined;
  baseUrl: string;
  isActivatedMigration: boolean;
  perpage = 10;
  TotalPages = 0;
  columns = [{name: 'pk', sort: 'asc', isCurrent: true},
    {name: 'firstName', sort: 'asc', isCurrent: false},
    {name: 'lastName', sort: 'asc', isCurrent: false},
    {name: 'company', sort: 'asc', isCurrent: false},
    {name: 'crmMasterId', sort: 'asc', isCurrent: false},
    {name: 'userRegistrationDate', sort: 'asc', isCurrent: false},
    {name: 'email', sort: 'asc', isCurrent: false},
    {name: 'active', sort: 'asc', isCurrent: false},
    {name: 'paidTo', sort: 'asc', isCurrent: false}];
  currentPageIndex = 0;
  totalItems = 0;
  searchString: string;
  pages: number[] = [];

  constructor(private adminService: AdminService,
              private apiService: ApiService,
              private notifications: NotificationsService,
              private translate: TranslateService,
              private modalService: ModalService) {
  }

  ngOnInit() {
    this.baseUrl = window.location.href.split('/#')[0];
    this.getUsersList(this.currentPageIndex, this.columns[0].name, this.columns[0].sort, '');
    this.adminService.isActivatedMigration()
      .subscribe((res) => {
        this.isActivatedMigration = res.toLowerCase() == 'true';
      }, (err) => {
        this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(err, this.translate.instant('apiMessages.webSignupError20')));
    });
  }

  getUsersList(page, columnName, Sort, search) {
    this.adminService.getUsers(page, this.perpage, columnName, Sort, search)
      .subscribe((res) => {
        let usersList = res.json();
        usersList = _.map(usersList, (user) => {
          user.isShown = false;
          user.paidTo = user.paidTo ? new Date(user.paidTo) : user.paidTo;
          user.userRegistrationDate = user.userRegistrationDate ? new Date(user.userRegistrationDate) : user.userRegistrationDate;
          return user;
        });
        
        this.usersList = usersList;
        this.totalItems = parseInt(res.headers.get('X-Total-Count'), 10);
        this.TotalPages = Math.ceil(this.totalItems / this.perpage);
        this.pages = [];
        for (let i = 0; i < this.TotalPages; i++) {
          this.pages.push(i);
        }
        // this.cd.markForCheck();
      }, (err) => {
        this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(err, this.translate.instant('admin.manageUsers.failedUsers')));
      });
  }

  searchData() {
    const current = _.find(this.columns, {isCurrent: true});
    this.getUsersList(this.currentPageIndex, current.name, current.sort, `${this.searchString ? this.searchString : ''}`);
  }

  sortCols(column) {
    const obj = _.find(this.columns, {name: column});
    _.each(this.columns, function (currColumn) {
      currColumn.isCurrent = false;
    });
    obj.isCurrent = true;

    if (obj.sort === 'asc') {
      obj.sort = 'desc';
    } else {
      obj.sort = 'asc';
    }
    this.getUsersList(this.currentPageIndex, obj.name, obj.sort, `${this.searchString ? this.searchString : ''}`);
  }

  pageIndexChange(pageIndex) {
    this.currentPageIndex = pageIndex - 1;
    const currentColumn = _.find(this.columns, {isCurrent: true});
    this.getUsersList(this.currentPageIndex, currentColumn.name, currentColumn.sort, `${this.searchString ? this.searchString : ''}`);
    return this.currentPageIndex + 1;
  }

  changeSelectedUser(user) {
  }

  resetTable(size) {
    this.perpage = parseInt(size, 10);
    const currentColumn = _.find(this.columns, {isCurrent: true});
    this.getUsersList(this.currentPageIndex, currentColumn.name, currentColumn.sort, `${this.searchString ? this.searchString : ''}`);
  }

  public async uploadMasterIdsCSVFile(event: any)  {
    const file: File = event.target.files[0];
    this.adminService.uploadMasterIdsCSVFile(file)
      .subscribe((res) => {
        this.notifications.info(this.translate.instant('common.success'), "Succesfully uploaded CSV file for Master Ids");
      }, (err) => {
        this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(err, "Error to upload CSV file for Master Ids"));
    });
  }

  public async uploadEmailsWithNoDealCSVFile(event: any)  {
    const file: File = event.target.files[0];
    this.adminService.uploadEmailsWithNoDealCSVFile(file)
      .subscribe((res) => {
        this.notifications.info(this.translate.instant('common.success'), "Succesfully uploaded CSV file for emails with no deals");
      }, (err) => {
        this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(err, "Error to upload CSV file for emails with no deals"));
    });
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/admin/manage-users/manage-users.component.ts